<template>
  <div>
    <div id="container">
      <phone2action-widget id="widget"/>
      <help-box />
    </div>
    <div id="footer">
      <span>{{ copyrightText }}</span>
    </div>
  </div>
</template>

<script>
import Phone2ActionWidget from '../components/Phone2ActionWidget.vue'
import HelpBox from '../components/HelpBox.vue'
import GeneralMixin from '../mixins/general.js'

export default {
  name: 'LandingPage',
  components: {
    "phone2action-widget": Phone2ActionWidget,
    "help-box": HelpBox,
  },
  mixins: [GeneralMixin],
  data() {
    return {
      copyrightText: "© 2020 American Federation for Children",
    }
  },
  mounted() {
    this.reloadWidgetIfNotThere();
  },
  methods: {
    reloadWidgetIfNotThere() {
      setTimeout(function(){
        if (!document.querySelector('.advocacy-actionwidget > iframe')) {
          location.reload();
        }
      }, 500)
    }
  }
}
</script>

<style scoped>
  @font-face {
    font-family: ProximaNovaSemiBold;
    src: url("../assets/proximanova-semibold.otf") format("opentype");
  }
  @font-face {
    font-family: ProximaNovaRegular;
    src: url("../assets/proxima-nova-regular.ttf") format("opentype");
  }
  #container {
    background-image: url('../assets/afc-kid.jpg');
    background-size:cover;
    height: 95vh;
    display: flex;
  }
  #footer {
    height: 5vh;
    color: #818ca4;
    background-color: #e7e5e2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #help-bubble-wrapper {
    font-family: ProximaNovaRegular;
    color: #1f3561;
    width: 186px;
    height: 88px;
    background-color: #ffffff;
    margin-left: auto;
    margin-right: 30px;
    margin-top: 24px;
    font-size: 16px;
    border-radius: 6px;
    border: solid 2px #1f3561
  }
  #help-bubble-title {
    font-family: ProximaNovaSemiBold;
  }
  #help-email {
    text-decoration: underline;
  }
  #email-link {
    color: #1f3561;
  }
  #help-bubble-inner {
    padding-left: 10px;
    padding-top: 10px;
    line-height: 1.2;
  }
  /* start of phone styles */
  @media screen and (max-width: 679px) {
    #help-bubble-wrapper {
      display: none;
    }
    #widget {
      width: 100%;
      height: 140vh;
    }
    #container{
      height: 100vh;
      background-image: none;
    }
    #footer{
      display: none;
    }
  }
</style>
